// extracted by mini-css-extract-plugin
export var avatar = "_q3-3";
export var avatarContainer = "_q3-2";
export var avatarSpacer = "_q3-5";
export var avatarSpacerContainer = "_q3-4";
export var avatarStackContainer = "_q3-1";
export var bubble = "_q3-0";
export var remainderBubble = "_q3-6";